<template lang="pug">
    v-toolbar(:color="colors.primary" dark app absolute clipped-left)
        span(class="title ml-3 mr-5") MENU AGROPLASTIC
        //v-text-field(solo-inverted flat label="Search" prepend-icon="search")
        v-spacer
        v-badge(class="mr-3" clor="red" title="Salir")
            a.ml-0(v-on:click="logout") 
                v-icon(:color="colors.backgroundColor") exit_to_app
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
export default {
    data: function(){
        return {
            // 
        }
    },
    methods:{
        logout: function () {
            event.preventDefault();
            this.logoutRequestAction()
            .then(() => {
                if (process.env.VUE_APP_BY_PASS_LOGIN === 'false')
                    this.$router.push('/login')
            })
            .catch(err => {
                console.log(err)
                if (process.env.VUE_APP_BY_PASS_LOGIN === 'false')
                    this.$router.push('/login')
            })
        },
        ...mapActions('AuthModule', {
            logoutRequestAction: 'logoutRequestAction'
        }),
    },
}
</script>
